import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { CommonUtility } from '../../utility/common.utility';

@Directive({
  selector: '[appFocusFirstFocusableElement]',
  standalone: false,
})
export class FocusFirstFocusableElementDirective implements AfterViewInit {
  constructor(private el: ElementRef<any>) {}

  public ngAfterViewInit(): void {
    const focusableElements: Element[] = CommonUtility.getFocusableElements(this.el.nativeElement);
    const firstFocusableElement: HTMLElement = focusableElements[0] as HTMLElement;
    if (firstFocusableElement) {
      CommonUtility.setFocusToElement(null, firstFocusableElement);
    }
  }
}
